var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDevOpsProcess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 58,
    viewBox: "0 0 58 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.7715 21.771H36.2324V36.2319H21.7715V21.771Z",
    stroke: "#D41E4D",
    strokeWidth: 3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0889 21.771V17.6377",
    stroke: "#D41E4D",
    strokeWidth: 3
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32.9121 21.771V17.6377",
    stroke: "#D41E4D",
    strokeWidth: 3
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0889 40.3628V36.2295",
    stroke: "#D41E4D",
    strokeWidth: 3
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M32.9121 40.3628V36.2295",
    stroke: "#D41E4D",
    strokeWidth: 3
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M36.2295 25.0884H40.3628",
    stroke: "#D41E4D",
    strokeWidth: 3
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M36.2295 32.9121H40.3628",
    stroke: "#D41E4D",
    strokeWidth: 3
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6396 25.0884H21.7707",
    stroke: "#D41E4D",
    strokeWidth: 3
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6396 32.9121H21.7707",
    stroke: "#D41E4D",
    strokeWidth: 3
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M29.0005 14.4364C28.9983 13.2117 28.73 12.0021 28.214 10.8914C27.698 9.78067 26.9468 8.79539 26.0123 8.00379C25.0778 7.21219 23.9823 6.63318 22.8019 6.30689C21.6215 5.98059 20.3842 5.91479 19.1758 6.11406C17.9674 6.31332 16.8168 6.77289 15.8036 7.46092C14.7904 8.14894 13.9389 9.04899 13.308 10.0987C12.6772 11.1485 12.282 12.3228 12.15 13.5404C12.018 14.7579 12.1522 15.9897 12.5433 17.1502C10.0595 17.9823 7.89994 19.5739 6.36988 21.7001C4.83981 23.8263 4.0166 26.3795 4.0166 28.999C4.0166 31.6185 4.83981 34.1718 6.36988 36.298C7.89994 38.4242 10.0595 40.0158 12.5433 40.8479C12.1522 42.0083 12.018 43.24 12.15 44.4574C12.282 45.6749 12.677 46.8492 13.3078 47.8989C13.9385 48.9486 14.7899 49.8486 15.8029 50.5367C16.8159 51.2248 17.9664 51.6844 19.1747 51.8838C20.383 52.0832 21.6202 52.0176 22.8006 51.6916C23.981 51.3655 25.0764 50.7867 26.011 49.9954C26.9456 49.204 27.697 48.219 28.2132 47.1085C28.7294 45.998 28.998 44.7885 29.0005 43.5639",
    stroke: "#D41E4D",
    strokeWidth: 3
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M29 14.4364C29.0011 13.2108 29.2688 12.0001 29.7845 10.8882C30.3001 9.77636 31.0514 8.78995 31.9863 7.99737C32.9211 7.20479 34.0172 6.625 35.1984 6.2982C36.3796 5.97139 37.6178 5.9054 38.8271 6.10478C40.0364 6.30417 41.1879 6.76416 42.2017 7.45288C43.2155 8.1416 44.0674 9.04256 44.6983 10.0933C45.3292 11.144 45.7241 12.3194 45.8555 13.538C45.9869 14.7565 45.8517 15.9891 45.4594 17.1502C47.9432 17.9823 50.1028 19.5738 51.6328 21.7C53.1629 23.8262 53.9861 26.3795 53.9861 28.999C53.9861 31.6185 53.1629 34.1718 51.6328 36.298C50.1028 38.4242 47.9432 40.0158 45.4594 40.8478C45.8494 42.0081 45.9826 43.2392 45.8499 44.456C45.7172 45.6729 45.3217 46.8463 44.6908 47.8953C44.06 48.9442 43.2087 49.8435 42.196 50.531C41.1833 51.2186 40.0333 51.6779 38.8256 51.8771C37.6179 52.0764 36.3813 52.011 35.2014 51.6852C34.0215 51.3595 32.9264 50.7814 31.992 49.9908C31.0575 49.2001 30.306 48.2159 29.7894 47.1063C29.2728 45.9966 29.0035 44.7879 29 43.5639",
    stroke: "#D41E4D",
    strokeWidth: 3
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1367 43.5842C12.1335 41.4309 12.9569 39.3584 14.437 37.7944",
    stroke: "#D41E4D",
    strokeWidth: 3
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1367 14.4365C12.1341 16.5891 12.9574 18.6606 14.437 20.224",
    stroke: "#D41E4D",
    strokeWidth: 3
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M45.8647 43.5842C45.8681 41.4308 45.0447 39.3583 43.5645 37.7944",
    stroke: "#D41E4D",
    strokeWidth: 3
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M45.8647 14.4365C45.8673 16.5891 45.044 18.6606 43.5645 20.224",
    stroke: "#D41E4D",
    strokeWidth: 3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDevOpsProcess);
export default __webpack_public_path__ + "static/media/DevOps_Process.8e8cd6da5020fd4adf739038c2073007.svg";
export { ForwardRef as ReactComponent };